// extracted by mini-css-extract-plugin
module.exports = {"button":"TireSizeButtons_button__wmtCS","outline":"TireSizeButtons_outline__IfEIe"};